/**
 * Lightbox plan tiers and their limits.
 *
 * Single source of truth: billing, entitlement checks and the settings UI all
 * read the limits from here rather than hardcoding numbers.
 *
 * `null` means unlimited for that dimension. A limit of `0` means the feature
 * is not available on the tier at all.
 */
export var PlanTier;
(function (PlanTier) {
    PlanTier["FREE"] = "free";
    PlanTier["STARTER"] = "starter";
    PlanTier["PRO"] = "pro";
    PlanTier["ENTERPRISE"] = "enterprise";
})(PlanTier || (PlanTier = {}));
/** Display order, cheapest first. Also the upgrade path. */
export const PLAN_TIER_ORDER = [
    PlanTier.FREE,
    PlanTier.STARTER,
    PlanTier.PRO,
    PlanTier.ENTERPRISE,
];
// ponytail: flat const map, not a DB table. Tiers change on release, not at
// runtime, so a table would need a migration per pricing change AND still need
// a fallback here. Move to a table only if tiers become tenant-editable.
export const PLAN_LIMITS = {
    [PlanTier.FREE]: {
        maxUsers: 3,
        maxProjects: 1,
        maxConnectors: 1,
        maxAiAgents: 1,
        maxAiTokensPerMonth: 100000,
        maxRequestsPerMonth: 1000,
        maxQueryRows: 10000,
        maxScheduledDeliveries: 0,
        maxAppBuildsPerMonth: 0,
    },
    [PlanTier.STARTER]: {
        maxUsers: 10,
        maxProjects: 3,
        maxConnectors: 3,
        maxAiAgents: 3,
        maxAiTokensPerMonth: 1000000,
        maxRequestsPerMonth: 25000,
        maxQueryRows: 100000,
        maxScheduledDeliveries: 10,
        maxAppBuildsPerMonth: 5,
    },
    [PlanTier.PRO]: {
        maxUsers: 50,
        maxProjects: 10,
        maxConnectors: 10,
        maxAiAgents: 25,
        maxAiTokensPerMonth: 10000000,
        maxRequestsPerMonth: 250000,
        maxQueryRows: 500000,
        maxScheduledDeliveries: 100,
        maxAppBuildsPerMonth: 50,
    },
    [PlanTier.ENTERPRISE]: {
        maxUsers: null,
        maxProjects: null,
        maxConnectors: null,
        maxAiAgents: null,
        maxAiTokensPerMonth: null,
        maxRequestsPerMonth: null,
        maxQueryRows: null,
        maxScheduledDeliveries: null,
        maxAppBuildsPerMonth: null,
    },
};
/** Organizations with no tier recorded keep working on the free limits. */
export const DEFAULT_PLAN_TIER = PlanTier.FREE;
export const getPlanLimits = (tier) => PLAN_LIMITS[tier];
/**
 * True when `usage` is at or above the limit, i.e. one more would exceed it.
 * `null` (unlimited) is never exceeded; `0` is always exceeded.
 */
export const isLimitReached = (limit, usage) => {
    if (limit === null)
        return false;
    return usage >= limit;
};
export const isPlanTier = (value) => Object.values(PlanTier).includes(value);
//# sourceMappingURL=planTiers.js.map